import React, { Component } from "react";
import DasLogo from "../assets/images/DAS-Powered-by-2x.png";
import $ from "jquery";

export default class Terms extends Component {
  state = {};

  showTermsAndConditions() {
    $("#reviewrequest").hide();

    $("#termsconditions").show();
    $("#termsconditions").scrollTop();
    $("#termsconditionslink").css("color", "#340e7a");
  }

  render() {
    return (
      <div className="terms-container">
        <div>
          <span>
            <p className="terms-paragraph-optout-text">
              You have been directed to this site because you selected a link in
              a text message. If you no longer wish to receive text messages of
              this kind, simply reply "Stop" to that original text message.
            </p>
            <p className="terms-paragraph">
              <a
                href="https://digitalairstrike.com/privacy/"
                className="terms-privacy-policy"
              >
                Privacy Policy
              </a>
            </p>
            <p className="terms-paragraph">
              <span
                id="termsconditionslink"
                className="terms-and-conditions-link"
                onClick={this.showTermsAndConditions}
              >
                Terms &amp; Conditions
              </span>
            </p>
          </span>
        </div>
        <div className="space"></div>
        <div>
          <div className="terms-contact-info">
            <a href="https://digitalairstrike.com">
              <img
                src={DasLogo}
                alt="Digital Air Strike Logo"
                className="terms-das-logo"
              ></img>
            </a>
            <div className="company-name">
              <strong>Digital Air Strike</strong>
            </div>
            <div className="terms-contact-info-text">1-866-925-8289</div>
            <div className="terms-contact-info-text">
              support@digitalairstrike.com
            </div>
            <div className="terms-contact-info-text">
              6991 East Camelback Road #B111
            </div>
            <div className="terms-contact-info-text">Scottsdale AZ 85251</div>
          </div>
        </div>
      </div>
    );
  }
}
